import React, { useEffect, useMemo, useState } from 'react';
import { ClockIcon } from 'lucide-react';
function pad(n: number) {
  return String(n).padStart(2, '0');
}
export function Countdown() {
  // Fixed target: end of today (urgency), persisted only for this session.
  const target = useMemo(() => {
    const t = new Date();
    t.setHours(23, 59, 59, 999);
    return t.getTime();
  }, []);
  const [remaining, setRemaining] = useState(target - Date.now());
  useEffect(() => {
    const id = setInterval(() => setRemaining(Math.max(0, target - Date.now())), 1000);
    return () => clearInterval(id);
  }, [target]);
  const totalSec = Math.floor(remaining / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor(totalSec % 3600 / 60);
  const s = totalSec % 60;
  const spotsPct = 47;
  return <div className="rounded-2xl border border-hockey-pink/40 bg-hockey-greendark/60 p-4" data-id="element-110" data-mp="10c3gnqivjy44">
      <div className="flex items-center justify-center gap-2 text-hockey-pink" data-id="element-111" data-mp="15by3nizj43jw">
        <ClockIcon className="h-5 w-5" data-id="element-112" data-mp="y0wujld43wkh" />
        <span className="text-xs font-bold uppercase tracking-widest" data-id="element-113" data-mp="xzvhxcgg720n">La oferta termina en</span>
      </div>

      <div className="mt-3 flex items-center justify-center gap-2" data-id="element-114" data-mp="t1k831q5krif">
        {[{
        v: h,
        l: 'Horas'
      }, {
        v: m,
        l: 'Min'
      }, {
        v: s,
        l: 'Seg'
      }].map((b, i) => <React.Fragment key={b.l} data-id="element-115" data-mp="12sety4zhlp3c" data-mpi={i}>
            <div className="flex w-16 flex-col items-center rounded-xl bg-black/50 py-2" data-id="element-116" data-mp="f2aso49ru1fi">
              <span className="font-display text-3xl leading-none text-white tabular-nums" data-id="element-117" data-mp="f45dlil1ltjl">{pad(b.v)}</span>
              <span className="mt-1 text-[10px] uppercase tracking-wide text-white/50" data-id="element-118" data-mp="o30mj2fh1hql">{b.l}</span>
            </div>
            {i < 2 && <span className="font-display text-2xl text-hockey-pink" data-id="element-119" data-mp="k15ktwtmp2ca">:</span>}
          </React.Fragment>)}
      </div>

      <div className="mt-4" data-id="element-120" data-mp="1zguoygld8qnu">
        <div className="mb-1.5 flex items-center justify-between text-[12px] font-semibold text-white/80" data-id="element-121" data-mp="1zk8lv9b9g7nw">
          <span data-id="element-122" data-mp="1viwzdcnoo2jx">Cupos restantes con este precio</span>
          <span className="text-hockey-pink" data-id="element-123" data-mp="s4v6nefe98fk">{spotsPct}%</span>
        </div>
        <div className="h-3 w-full overflow-hidden rounded-full bg-black/50" data-id="element-124" data-mp="x3yef6mrdsr8">
          <div className="h-full rounded-full bg-hockey-pink transition-all" style={{
          width: `${spotsPct}%`
        }} data-id="element-125" data-mp="1243ya0mseayr" />
        </div>
        <p className="mt-1.5 text-center text-[11px] text-white/50" data-id="element-126" data-mp="164mtm4nw1z5p">
          ⚠️ Quedan pocos cupos al precio de lanzamiento
        </p>
      </div>
    </div>;
}